export default __webpack_public_path__ + "static/media/unity-list.27258464.svg";